import { z } from "zod";

export type Coordinate = z.infer<typeof CoordinateSchema>;
const CoordinateSchema = z.object({
    latitude: z.string(), //WGS84 Latitude
    longitude: z.string(), //WGS84 Longitude
});

export type Address = z.infer<typeof AddressSchema>;
const AddressSchema = z.object({
    addressId: z.string(),
    city: z.string(),
    coordinate: CoordinateSchema,
    county: z.string(),
    houseNumber: z.number(),
    letter: z.string().nullable(),
    municipality: z.string(),
    postalCode: z.string(),
    streetName: z.string(),
    type: z.enum(["STREET", "PLACE", "POSTAL_PLACE", "PO_BOX"]),
});

export type Navigation = z.infer<typeof NavigationSchema>;
const NavigationSchema = z.object({
    self: z.string(),
    totalHits: z.number(),
});

export type BringAddressesResponse = z.infer<typeof BringAddressesResponseSchema>;
export const BringAddressesResponseSchema = z.object({
    addresses: z.array(AddressSchema),
    navigation: NavigationSchema,
});